import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import {
    ColliConfezInsertTable,
    ColliConfezObj,
    ColliConfezPaginationFilterRequest,
    ColliConfezResponse,
    ColliConfezUpdate,
    ColliConfezUpdateResponse
} from '../features/colliConfez/colliConfezSlice'
import {
    ColliConfezRigheObj,
    ColliConfezRigheObjInsert,
    ColliConfezRigheObjUpdate,
    ColliConfezRighePaginationFilterRequest,
    ColliConfezRigheResponse,
} from '../features/colliConfezRighe/colliConfezRigheSlice'

export const api = createApi({
    baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_ENDPOINT }),
    reducerPath: 'api',
    tagTypes: ['colliConfezRighe'],
    refetchOnFocus: false,
    refetchOnReconnect: true,
    endpoints: (build) => ({
        // --------------------------------------------------------------------------------------
        // ------ COLLI_CONFEZ ------------------------------------------------------------------
        // --------------------------------------------------------------------------------------
        getColliConfez: build.query<ColliConfezResponse, ColliConfezPaginationFilterRequest>({
            query: (args) => {
                const params = new URLSearchParams({ data: JSON.stringify(args, null, 0) })
                return `/colliConfez?${params.toString()}`
            },
            transformResponse: (response: ColliConfezResponse) => {
                return response
            },
        }),
        updateColliConfez: build.mutation<ColliConfezUpdateResponse, ColliConfezUpdate>({
            query: (body) => ({
                url: `/colliConfez`,
                method: 'PUT',
                body,
            }),
        }),
        insertColliConfez: build.mutation<ColliConfezResponse, ColliConfezInsertTable>({
            query: (body) => ({
                url: `/colliConfez`,
                method: 'POST',
                body,
            }),
        }),
        deleteColliConfez: build.mutation<ColliConfezResponse, ColliConfezObj>({
            query: (body) => ({
                url: `/colliConfez`,
                method: 'DELETE',
                body,
            }),
        }),
        // --------------------------------------------------------------------------------------
        // ------ COLLI_CONFEZ_RIGHE ------------------------------------------------------------
        // --------------------------------------------------------------------------------------
        getColliConfezRighe: build.query<ColliConfezRigheResponse, ColliConfezRighePaginationFilterRequest>({
            query: (args) => {
                const params = new URLSearchParams({ data: JSON.stringify(args, null, 0) })
                return `/colliConfezRighe?${params.toString()}`
            },
            transformResponse: (response: ColliConfezRigheResponse) => {
                return response
            },
            providesTags: ['colliConfezRighe'],
        }),
        updateColliConfezRighe: build.mutation<ColliConfezRigheResponse, ColliConfezRigheObjUpdate>({
            query: (body) => ({
                url: `/colliConfezRighe`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['colliConfezRighe'],
        }),
        insertColliConfezRighe: build.mutation<ColliConfezRigheResponse, ColliConfezRigheObjInsert>({
            query: (body) => ({
                url: `/colliConfezRighe`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['colliConfezRighe'],
        }),
        deleteColliConfezRighe: build.mutation<ColliConfezRigheResponse, ColliConfezRigheObj>({
            query: (body) => ({
                url: `/colliConfezRighe`,
                method: 'DELETE',
                body,
            }),
            invalidatesTags: ['colliConfezRighe'],
        }),
    }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    // ------ COLLI_CONFEZ ------------------------------------------------------------------
    useLazyGetColliConfezQuery,
    useUpdateColliConfezMutation,
    useInsertColliConfezMutation,
    useDeleteColliConfezMutation,
    // ------ COLLI_CONFEZ_RIGHE ------------------------------------------------------------
    useGetColliConfezRigheQuery,
    useUpdateColliConfezRigheMutation,
    useInsertColliConfezRigheMutation,
    useDeleteColliConfezRigheMutation,
} = api
